import {Injectable} from "@angular/core";
import {AppSettingsService} from "../../../shared/services/app-settings.service";
import {CommonApiService} from "../../../shared/services/api/common-api.service";
import {BehaviorSubject, Observable} from "rxjs";
import {UserService} from "../../../shared/services/user.service";
import {PortalApiService} from "../../../shared/services/api/portal-api.service";
import {DirectoryMocksService} from "./directory-mocks.service";
import { finalize, map } from "rxjs/operators";

const apiEndpoints = {
  activeDirectorySearch: 'common/activedirectorysearch',
  allDirectorySearch: 'common/directorysearch',
  badgeSearch: 'common/badge/{badge}'
};

@Injectable()
export class DirectoryService {

  constructor(private appSettings: AppSettingsService,
              private portalApiService: PortalApiService,
              private commonService: CommonApiService,
              private userService: UserService,
              private directoryMocksService: DirectoryMocksService) {
  }

  getStates() {
    return this.commonService.getStates();
  }

  getCredentials() {
    return this.commonService.getCredentials();
  }

  getActiveDirectorySearch(
    offset: number,
    pageLimit: number,
    firstName: string,
    lastName: string,
    birthdate: string,
    credential: string,
    city: string,
    state: string
  ): Observable<any> {
    if (this.userService.isCurrentUserMock) {
      return new BehaviorSubject<any>(
        this.handleApiResponse(this.directoryMocksService.getActiveSearch(offset))
      );
    }
  
    const query = `offSet=${offset}&limit=${pageLimit}&sortColumn=lastName&sortDir=ASC&firstName=${firstName}&lastName=${lastName}&state=${state}&credential=${credential}&city=${city}&birthDate=${birthdate}`;
  
    return this.portalApiService
      .getActiveDirectory(apiEndpoints.activeDirectorySearch, query)
      .pipe(
        map((res: Response) => this.handleApiResponse(res)),
        finalize(() => null)
      );
  }

  getAllDirectorySearch(
    offset: number,
    pageLimit: number,
    firstName: string,
    lastName: string,
    birthdate: string,
    credential: string,
    city: string,
    state: string
  ): Observable<any> {
    if (this.userService.isCurrentUserMock) {
      return new BehaviorSubject<any>(
        this.handleApiResponse(this.directoryMocksService.getActiveSearch(offset))
      );
    }
  
    const query = `offSet=${offset}&limit=${pageLimit}&sortColumn=lastName&sortDir=ASC&firstName=${firstName}&lastName=${lastName}&state=${state}&credential=${credential}&city=${city}&birthDate=${birthdate}`;
  
    return this.portalApiService
      .getAllDirectory(apiEndpoints.allDirectorySearch, query)
      .pipe(
        map((res: Response) => this.handleApiResponse(res)),
        finalize(() => null)
      );
  }

  getBadge(badge: string): Observable<any> {
    return this.portalApiService
      .get(apiEndpoints.badgeSearch.replace('{badge}', badge))
      .pipe(
        map((res: Response) => res),
        finalize(() => null)
      );
  }

  private handleApiResponse(response: any): any {
    try {
      return response;
    }
    catch (e) {
      if (this.appSettings.IsDebugEnabled) {console.error(e);}
      return null;
    }
  }
}
